import { bookingsApi } from "@/lib/api";

/* ── Booking Service ───────────────────────────────────────────
   Wraps bookingsApi.create() to map frontend booking data
   to the backend BookingRequest shape.
   BACKEND: POST /api/v1/bookings — See api.ts bookingsApi.create()
   ─────────────────────────────────────────────────────────────── */

export interface BookingData {
  venueId: string;
  roomTypeId?: string;
  checkIn: string;
  checkOut: string;
  guests: number;
  totalPrice: number;
  customerName: string;
  customerEmail: string;
}

export const BookingService = {
  async createBooking(data: BookingData): Promise<{ id: string; status: string; paymentDeadline?: string }> {
    const res = await bookingsApi.create({
      venueId: data.venueId,
      roomTypeId: data.roomTypeId,
      startDate: data.checkIn,
      endDate: data.checkOut,
      guestName: data.customerName,
      guestEmail: data.customerEmail,
      totalAmount: data.totalPrice,
    });
    return { id: res.id, status: res.status, paymentDeadline: res.paymentDeadline };
  },

  async pay(bookingId: string, paymentMethod?: "wallet" | "bank_transfer"): Promise<{
    bookingRef: string;
    amount: number;
    status: string;
    paymentStatus: string;
    paymentDeadline?: string;
    dedicatedBank: {
      accountNumber: string;
      accountName: string;
      bankName: string;
    } | null;
  }> {
    return bookingsApi.pay(bookingId, paymentMethod);
  },
};
